module.exports = __webpack_public_path__ + "static/2021_image-0052245043a30d59f5046f5fa4691179.png";